import React from 'react';
import { ResolvedImg } from '../utils/imageResolver';
import './ContentSection.css';

const ContentSection = ({
    title,
    subtitle,
    contentText,
    contentList,
    contentDisplaySide = 'left',
    backgroundImageUrl
}) => {
    const isLeft = contentDisplaySide === 'left';
    
    return (
        <section className="content-section">
            <div className="container">
                <div className={`content-section-wrapper ${isLeft ? 'content-left' : 'content-right'}`}>
                    {/* Background Image */}
                    {backgroundImageUrl && (
                        <div 
                            className="content-background-image"
                            style={{
                                backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.92) 0%, rgba(255, 255, 255, 0.88) 5%, rgba(255, 255, 255, 0.83) 10%, rgba(255, 255, 255, 0.76) 15%, rgba(255, 255, 255, 0.68) 20%, rgba(255, 255, 255, 0.59) 25%, rgba(255, 255, 255, 0.50) 30%, rgba(255, 255, 255, 0.41) 35%, rgba(255, 255, 255, 0.33) 40%, rgba(255, 255, 255, 0.26) 45%, rgba(255, 255, 255, 0.20) 50%, rgba(255, 255, 255, 0.10) 55%, transparent 100%), url(${backgroundImageUrl})`
                            }}
                        />
                    )}
                    
                    {/* Text Content */}
                    <div className="content-text-area">
                        {title && (
                            <h2 className="content-title">{title}</h2>
                        )}
                        {subtitle && (
                            <p className="content-subtitle">{subtitle}</p>
                        )}
                        
                        {contentText && (
                            <div className="content-text">
                                <span className="quote-mark quote-mark-start">"</span>
                                <p>{contentText}</p>
                                <span className="quote-mark quote-mark-end">"</span>
                            </div>
                        )}
                        
                        {contentList && Array.isArray(contentList) && contentList.length > 0 && (
                            <ul className="content-list">
                                {contentList.map((item, index) => (
                                    <li key={index} className="content-list-item">
                                        <h3 className="content-list-title">{item.title}</h3>
                                        {item.description && (
                                            <p className="content-list-description">{item.description}</p>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContentSection;

